export enum RoleTypeEnum {
	Doctor = 0,
	Lab = 1,
	Technician = 2
}
